<template>
	<div class="w100 bgWhite">
        <el-row class="p15">
            <el-col :span="20"><div class="grid-content fontDark font14">全国主要城市行情地图</div></el-col>
            <el-col :span="4"><div class="grid-content fontDark textRight font14 pointer fontBold" @click="goBasePrice()">详情+</div></el-col>
        </el-row>
        <img src="../assets/images/ej/map.png" alt="" style="height: 300px;" class="w100">
	</div>
</template>

<script>
	import { navigationUrl, baseUrl } from '../assets/js/common'
	export default {
	    name: 'MapControl',
	    data () {
	        return {
				hasBasePrice: false
			}
	    },
	    mounted () {
			// 初始化内容
			this.findNaTree();
	    },
	    methods: {
			//页面操作
			findNaTree () {
				const self = this;
				const token_cyw = self.$cookies.get('token_cyw');
				let url = ``;
				if (token_cyw) {
					self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
						if (res_1.status == 200) {
							url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=Y`;
						} else {
							url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
						}
						self.$get(url, {}).then(res => {
							if (res.code == 0) {
								res.data.forEach((item, index) => {
									if (item.navigationName == '基准价') {
										self.hasBasePrice = true;
									}
								})
							} else {
								// self.$message.error(res.message);
							}
						}).catch(err => {
							// self.$message.error('未获取到二级菜单信息');
						})
					})
				} else {
					url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
					self.$get(url, {}).then(res => {
						if (res.code == 0) {
							self.submenu_list_1 = [];
							res.data.forEach((item, index) => {
								if (item.navigationName == '基准价') {
									self.hasBasePrice = true;
								}
							})
						} else {
							// self.$message.error(res.message);
						}
					}).catch(err => {
						// self.$message.error('未获取到二级菜单信息');
					})
				}
			},
			goBasePrice () {
				if (this.hasBasePrice) {
					this.$router.push(navigationUrl['基准价'])
				}
			}
	    },
	}
</script>

<style>
	.map-top { box-sizing: border-box; height: 360px }
</style>
